var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobilelogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0554 0.673658C11.0554 0.290258 10.7433 -0.0228272 10.3594 0.00130804C9.14566 0.0776257 7.9512 0.353184 6.82466 0.81834C5.48336 1.37217 4.26463 2.18394 3.23804 3.2073C2.21146 4.23065 1.39712 5.44554 0.84154 6.78262C0.285955 8.11969 -1.26921e-07 9.55276 0 11C1.26922e-07 12.4472 0.285956 13.8803 0.84154 15.2174C1.39712 16.5545 2.21146 17.7694 3.23804 18.7927C4.26463 19.8161 5.48336 20.6278 6.82466 21.1817C7.9512 21.6468 9.14566 21.9224 10.3594 21.9987C10.7433 22.0228 11.0554 21.7097 11.0554 21.3263L11.0554 0.673658Z",
    fill: "url(#paint0_linear_425_3185)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9744 2.92978C16.9744 2.54638 16.662 2.2326 16.2787 2.26415C14.2478 2.43135 12.332 3.32654 10.8806 4.8026C9.26441 6.44624 8.35645 8.67549 8.35645 10.9999C8.35645 13.3244 9.26441 15.5537 10.8806 17.1973C12.332 18.6734 14.2478 19.5685 16.2787 19.7357C16.662 19.7673 16.9744 19.4535 16.9744 19.0701V2.92978Z",
    fill: "url(#paint1_linear_425_3185)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_425_3185",
    x1: -0.134062,
    y1: 24.3366,
    x2: 17.0901,
    y2: -2.82378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0194FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FF8D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_425_3185",
    x1: 8.25194,
    y1: 21.594,
    x2: 22.0426,
    y2: 0.254032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0194FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FF8D1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilelogo);
export default __webpack_public_path__ + "static/media/Mobilelogo.13621d5d72f47779d0b47c0165190da6.svg";
export { ForwardRef as ReactComponent };